import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=4c09a12c&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HomeIcon.vue?vue&type=style&index=0&id=4c09a12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09a12c",
  null
  
)

export default component.exports